import { EMAIL, NAV_LINKS, WA_MESSAGES, waLink, scrollToId } from "./data";

const Footer = () => (
  <footer
    className="border-t border-ivory/10 bg-obsidian pb-24 md:pb-0"
    data-testid="footer"
  >
    <div className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/assets/logo-light.png"
            alt="Elevate Estates"
            className="h-14 w-14 object-contain"
          />
          <p className="mt-6 font-serif text-2xl italic leading-snug text-ivory/85">
            The Right Space.
            <br />
            The Right Tenant.
            <br />
            The Right Deal.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] font-medium uppercase tracking-[0.28em] text-stone">
            Navigate
          </div>
          <div className="mt-5 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                type="button"
                onClick={() => scrollToId(l.href)}
                className="w-fit text-sm text-ivory/70 transition-colors duration-300 hover:text-champagne"
                data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => scrollToId("#contact")}
              className="w-fit text-sm text-ivory/70 transition-colors duration-300 hover:text-champagne"
              data-testid="footer-nav-contact"
            >
              Contact
            </button>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] font-medium uppercase tracking-[0.28em] text-stone">
            Contact
          </div>
          <div className="mt-5 flex flex-col gap-3 text-sm text-ivory/70">
            <span>Bengaluru, India</span>
            <a
              href={waLink(WA_MESSAGES.talk)}
              target="_blank"
              rel="noreferrer"
              className="w-fit transition-colors duration-300 hover:text-champagne"
              data-testid="footer-whatsapp-link"
            >
              WhatsApp
            </a>
            <a
              href={`mailto:${EMAIL}`}
              className="w-fit break-all transition-colors duration-300 hover:text-champagne"
              data-testid="footer-email-link"
            >
              {EMAIL}
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] font-medium uppercase tracking-[0.28em] text-stone">
            Social
          </div>
          <div className="mt-5 flex flex-col gap-3 text-sm text-ivory/70">
            <a href="#" className="w-fit transition-colors duration-300 hover:text-champagne" data-testid="footer-linkedin-link">
              LinkedIn
            </a>
            <a href="#" className="w-fit transition-colors duration-300 hover:text-champagne" data-testid="footer-instagram-link">
              Instagram
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-ivory/10 pt-6 text-[11px] tracking-[0.14em] text-stone/70">
        <span data-testid="footer-copyright">© 2026 Elevate Estates</span>
        <span className="flex gap-6">
          <a href="#" className="transition-colors duration-300 hover:text-ivory" data-testid="footer-privacy-link">
            Privacy
          </a>
          <a href="#" className="transition-colors duration-300 hover:text-ivory" data-testid="footer-terms-link">
            Terms
          </a>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
